<template>
  <v-container fluid class="admin-page">
    <v-row class="align-center justify-space-between">
      <v-col cols="2">
        <v-btn
          class="text--futura text-capitalize"
          outlined
          @click="goBack"
        >
          Back to Affiliates
        </v-btn>
      </v-col>
      <v-col cols="5">
        <h2>Affiliate Details</h2>
      </v-col>
      <v-col cols="2">
        <v-btn
          class="text--futura text--white text-capitalize"
          dark
          block
          @click="editAffiliate"
        >
          Edit Affiliate
        </v-btn>
      </v-col>
    </v-row>

    <v-row>
      <v-col cols="12">
        <Alert />
      </v-col>
    </v-row>

    <v-row class="crystal-admin-form justify-space-around pt-5">
      <v-col cols="4">
        <label>Full Name:</label>
        <v-text-field solo readonly :value="affiliate.fullName"></v-text-field>
      </v-col>
      <v-col cols="4">
        <label>Affiliate Code:</label>
        <v-text-field
          solo
          readonly
          :value="affiliate.affiliateCode"
        ></v-text-field>
      </v-col>
      <v-col cols="4">
        <label>Contact Number:</label>
        <v-text-field
          solo
          readonly
          :value="affiliate.contactNumber"
        ></v-text-field>
      </v-col>
    </v-row>

    <v-row class="mt-4">
      <v-col cols="12">
        <h3>Orders</h3>
        <v-data-table
          :loading="tableLoading"
          :headers="headers"
          :items="affiliateOrders"
          :items-per-page="10"
          class="elevation-1"
        >
          <template v-slot:[`item.grandTotal`]="{ item }">
            {{ formatHarga(item.grandTotal || getGrandTotal(item)) }}
          </template>
          <template v-slot:[`item.shipping`]="{ item }">
            {{ formatHarga(item.shippingFee || getShipping(item)) }}
          </template>
          <template v-slot:[`item.date`]="{ item }">
            {{ formatDate(item.orderDate || item.order_date || item.createdAt) }}
          </template>
          <template v-slot:[`item.paymentStatus`]="{ item }">
            {{ formatPaymentStatus(item.paymentStatus || item.OrderStatus) }}
          </template>
          <template v-slot:[`item.shipmentStatus`]="{ item }">
            {{ item.shipmentStatus || item.ShipStatus || "-" }}
          </template>
        </v-data-table>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import dayjs from "dayjs";
import Alert from "@/components/Alert.vue";

export default {
  name: "DetailAffiliate",
  components: {
    Alert,
  },
  data() {
    return {
      headers: [
        { text: "Order ID", value: "orderId" },
        { text: "Grand Total", value: "grandTotal", sortable: false },
        { text: "Shipping", value: "shipping", sortable: false },
        { text: "Date", value: "date", sortable: false },
        { text: "Payment Status", value: "paymentStatus", sortable: false },
        { text: "Shipment Status", value: "shipmentStatus", sortable: false },
      ],
    };
  },
  computed: {
    affiliate() {
      return this.$store.state.affiliate || {};
    },
    affiliateOrders() {
      return this.affiliate.AffiliateOrders || this.affiliate.Orders || [];
    },
    tableLoading() {
      return this.$store.state.tableLoading;
    },
  },
  methods: {
    goBack() {
      this.$router.push({ name: "Affiliate" });
    },
    editAffiliate() {
      this.$router.push({
        path: `/dashboard/edit/affiliate/${this.$route.params.id}`,
      });
    },
    formatDate(date) {
      return date ? dayjs(date).format("DD/MM/YYYY") : "-";
    },
    formatHarga(price) {
      return new Intl.NumberFormat("id-ID", {
        style: "currency",
        currency: "IDR",
        minimumFractionDigits: 0,
      }).format(price || 0);
    },
    getGrandTotal(order) {
      if (order.OrderLine && order.OrderLine.grand_total) return order.OrderLine.grand_total;
      if (order.grand_total) return order.grand_total;
      return 0;
    },
    getShipping(order) {
      if (order.delivery_fee) return order.delivery_fee;
      if (order.shipping) return order.shipping;
      return 0;
    },
    formatPaymentStatus(status) {
      if (!status) return "-";
      return status
        .split("_")
        .map((item) => item.charAt(0).toUpperCase() + item.slice(1))
        .join(" ");
    },
  },
  created() {
    this.$store.dispatch("getAffiliateById", { id: this.$route.params.id });
  },
};
</script>

<style></style>
